import Moment from "moment";

export class DateTimeDuration {
  static today(): DateTimeDuration {
    const now = new Date();
    return new DateTimeDuration(now, now);
  }

  static fromDays(from: Date, days: number): DateTimeDuration {
    return DateTimeDuration.createDateDuration(from, Moment(from).add(days, "days").toDate());
  }

  static fromMonths(from: Date, months: number): DateTimeDuration {
    return DateTimeDuration.createDateDuration(from, Moment(from).add(months, "months").toDate());
  }

  private static createDateDuration(a: Date, b: Date): DateTimeDuration {
    return (a <= b)
      ? new DateTimeDuration(a, b)
      : new DateTimeDuration(b, a);
  }

  static areEqual(a: DateTimeDuration, b: DateTimeDuration) {
    return (a === b)
      || ((a && b)
        && DateTimeDuration.areDatesEqual(a.from, b.from)
        && DateTimeDuration.areDatesEqual(a.to, b.to));
  }

  private static areDatesEqual(a: Date, b: Date): boolean {
    return (a === b)
      || ((a && b)
        && (a.getTime() === b.getTime()));
  }

  constructor(a: Date, b: Date) {
    this._from = this.createNewDate(a);
    this._to = this.createNewDate(b);
  }

  private createNewDate(source: Date): Date {
    return !source
      ? null
      : new Date(
        source.getFullYear(),
        source.getMonth(),
        source.getDate(),
        source.getHours(),
        source.getMinutes(),
        source.getSeconds(),
        source.getMilliseconds()
      );
  }

  private _from: Date;
  private _to: Date;

  get from(): Date {
    return this._from;
  }

  set from(value: Date) {
    this._from = this.createNewDate(value);
  }

  get to(): Date {
    return this._to;
  }

  set to(value: Date) {
    this._to = this.createNewDate(value);
  }

  clone(): DateTimeDuration {
    return new DateTimeDuration(this.from, this.to);
  }
}
